import { Button, HStack } from '@chakra-ui/react';
import React, { FC, useState } from 'react';

import { useLocationContext } from '@app/context/LocationContext';
import { VaultPositionActionsModal } from '@app/screens/positions/components/VaultPositionActionsModal';
import { BigNumber } from 'ethers';
import { Vault } from '@app/hooks/plugins/useVaults';
import { Pool } from '@app/types/pool';
import { Tooltip } from '@app/components/Tooltip';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import clsx from 'clsx';

import s from './VaultPositionControls.module.scss';

interface Props {
  data: {
    totalAmounts: [BigNumber, BigNumber] | undefined;
    totalSupply: BigNumber | undefined;
    balance: BigNumber | undefined;
    token0: BigNumber | undefined;
    token1: BigNumber | undefined;
    vault: Vault;
  };
  poolInfo: Pool;
  fullWidth?: boolean;
}

export const VaultPositionControls: FC<Props> = ({
  data,
  fullWidth,
  poolInfo
}) => {
  const { isReadOnly } = useLocationContext();
  const [view, setView] = useState<{
    type: 'add' | 'withdraw';
  } | null>(null);

  if (isReadOnly) {
    return null;
  }

  return (
    <>
      <HStack justify={['space-around', 'flex-end']} width="100%">
        <Tooltip
          tooltip="Withdraw"
          className={clsx({
            [s.fullWidth]: fullWidth
          })}
          triggerClassName={clsx({
            [s.fullWidth]: fullWidth
          })}
        >
          <Button
            width="100%"
            variant="secondary"
            onClick={() => {
              setView({
                type: 'withdraw'
              });
            }}
          >
            <FileUploadOutlinedIcon sx={{ width: '14px', height: '14px' }} />
          </Button>
        </Tooltip>
      </HStack>
      <VaultPositionActionsModal
        onClose={() => setView(null)}
        isOpen={view !== null}
        data={data}
        poolInfo={poolInfo}
      />
    </>
  );
};
